import { IoClose } from "react-icons/io5";
import userPlaceholder from "../assets/images/users/user-vector.png";
import axios from "axios";
import { UPDATE_USER_PASSWORD } from "../Routes";
import { generateURLOptions } from "../URLOptions";
import FilledButton from "../InterstellrComponents/FilledButton";
import CommonTextField from "../InterstellrComponents/CommonTextField";
import { useEffect, useState } from "react";
import { FaEye, FaRegEye } from "react-icons/fa";

const UserResetPasswordModal = ({ isOpen, onClose, person, onUpdate }) => {
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const resetPassword = async () => {
    if (password.toString() !== confirmPassword.toString()) {
      return alert("Please enter matching passwords to continue");
    }

    try {
      const response = await axios.post(
        UPDATE_USER_PASSWORD,
        {
          userId: person?._id,
          password,
          confirmPassword,
        },
        {
          headers: generateURLOptions(),
        },
      );

      console.log("Password Reset Response: ", response.data);
      onClose();
      return onUpdate();
    } catch (error) {
      console.log("Password Reset Error:", error);
      return alert(error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setPassword(null);
      setConfirmPassword(null);
      setShowPassword(false);
      setShowConfirm(false);
    }
  }, [isOpen]);

  return (
    // Overlay with fade transition
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Modal Container with scale and fade */}
      <div
        className={`bg-white rounded-xl w-full max-w-sm mx-4 p-4 relative shadow-xl transition-all duration-300 ${
          isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close"
        >
          <IoClose />
        </button>
        {/* Profile Header */}
        <div className="flex flex-row items-center mb-3">
          <img
            src={person?.profileImage ?? userPlaceholder}
            className="w-10 h-10 object-cover rounded-full"
            alt={person?.firstname ?? ""}
          />

          {/* User Profile Details */}
          <div className="flex flex-col ml-3">
            <h4 className="text-black font-medium text-base">
              {person?.firstname ?? ""} {person?.lastname ?? ""}
            </h4>

            <p className="text-black text-sm">{person?.email ?? ""}</p>
          </div>
        </div>

        <CommonTextField
          title={"New Password"}
          placeholder={"Password"}
          onChange={setPassword}
          value={password}
          type={"password"}
          showPassword={showPassword}
          suffixIcon={
            <div
              className="cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaEye className="mr-3 text-lg text-mpPurple" />
              ) : (
                <FaRegEye className="mr-3 text-lg text-mpPurple" />
              )}
            </div>
          }
        />

        <CommonTextField
          title={"Confirm New Password"}
          placeholder={"Confirm Password"}
          onChange={setConfirmPassword}
          value={confirmPassword}
          type={"password"}
          showPassword={showConfirm}
          suffixIcon={
            <div
              className="cursor-pointer"
              onClick={() => setShowConfirm(!showConfirm)}
            >
              {showConfirm ? (
                <FaEye className="mr-3 text-lg text-mpPurple" />
              ) : (
                <FaRegEye className="mr-3 text-lg text-mpPurple" />
              )}
            </div>
          }
        />
        <FilledButton text={"Reset Password"} onPress={resetPassword} />
      </div>
    </div>
  );
};

export default UserResetPasswordModal;
